

import { createContext, useContext, useEffect, useState } from "react";
import NodeAPI from "../api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (token && userId) {
            NodeAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`; // Set token for future requests

            NodeAPI.get(`/auth/user/${userId}`)
                .then(({ data }) => setUser(data))
                .catch(() => logout())
                .finally(() => setLoading(false)); // Ensure loading is updated only after fetch
        } else {
            setLoading(false);
        }
    }, []);

    const login = (userData, token) => {
        localStorage.setItem("token", token);
        localStorage.setItem("userId", userData.id);
        NodeAPI.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        setUser(userData);
    };

    const logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        delete NodeAPI.defaults.headers.common["Authorization"];
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, loading }}>
            {!loading ? children : <div>Loading...</div>} {/* Prevents flashing login page */}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
